import { createContext } from 'react';

export const AuthContext = createContext({
  isLoggedIn: false,
  token: null,
  userId: null,
  employeeId: null,
  userRecordId: null,
  userEmail: null,
  userFirstName: null,
  userLastName: null,
  isAdmin: false,
  isTimecard: false,
  isWorkflow: false,
  isAnalytics: false,
  isSuperAdmin: false,
  // Project Documents (#250) is switched on and confirmed for this session.
  projectDocumentsEnabled: false,
  homeUnion: null,
  login: () => {},
  logout: () => {},
});
